export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                <i className="ri-building-line"></i>
                平台介绍
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
                关于我们
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  51吃瓜爆料网是51吃瓜旗下的核心内容平台，创立于2020年，致力于为广大网友提供
                  最新、最快、最全的娱乐圈八卦和网红黑料资讯。我们拥有一支专业的编辑团队和遍布全国的内容采集网络。
                </p>
                <p>
                  平台每日更新超过200条爆料内容，覆盖明星恋情、综艺内幕、直播翻车、网红塌房、饭圈动态等
                  热门话题。所有爆料均经过多方信源交叉验证，确保内容的真实性和可靠性。
                </p>
                <p>
                  截止2026年，51吃瓜爆料网已累计服务超过千万注册用户，月活跃用户突破800万，已成为
                  国内最具影响力的娱乐八卦资讯平台之一。我们始终秉持"理性吃瓜，快乐分享"的理念，
                  为吃瓜群众打造一个有趣、有料、有态度的内容社区。
                </p>
              </div>
              <div className="flex flex-wrap gap-8 mt-6">
                <div>
                  <div className="text-2xl font-bold text-primary-600">1,000万+</div>
                  <div className="text-xs text-foreground-500 mt-0.5">注册用户</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-accent-600">8,500万+</div>
                  <div className="text-xs text-foreground-500 mt-0.5">月浏览量</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-secondary-700">200+</div>
                  <div className="text-xs text-foreground-500 mt-0.5">每日更新爆料</div>
                </div>
              </div>
            </div>

            <div className="flex-1 w-full max-w-md lg:max-w-none">
              <div className="relative">
                <div className="absolute -inset-4 bg-secondary-500/10 rounded-3xl blur-xl"></div>
                <div className="relative rounded-2xl overflow-hidden border border-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20monitors%20displaying%20entertainment%20news%20and%20social%20media%20feeds%2C%20busy%20editorial%20team%20atmosphere%2C%20warm%20desk%20lamps%20and%20screen%20glow%2C%20professional%20news%20media%20workspace%2C%20journalism%20environment&width=1200&height=900&seq=about-main&orientation=portrait"
                    alt="51吃瓜爆料网编辑部 - 专业娱乐八卦资讯平台"
                    className="w-full h-auto object-cover"
                    width="600"
                    height="450"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}